<script>
import Loader from "@/components/widgets/loader";

export default {
    name: 'StatusQuery',
    components: { Loader },
    props:[
        "data"
    ],
    data() {
        return {
            form: {},
            loading:true,
            response:[]
        };
    }, 
    watch:{
        data(props){
            this.form = {...props}
            this.response = []
            this.loading = true
            this.query()
        }
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('status_query')
        },
        async query(){
            await this.$http.get('/vae/appControl/' + this.form.id)
                // eslint-disable-next-line no-console
                .then(resp => { 
                    this.response = resp.data.content
                 })
                .catch(error => error)
                .finally( () =>  this.loading=false )
                
        },
    },
};
</script>

<template>
<b-modal id="status_query" :title="`${form.fullname}`"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="row mb-3">
            <label class="col-sm-5 col-form-label col-form-label">Başvuru Tarihi:</label>
            <div class="col col-form-label col-form-label">
                {{form.created_at}}
            </div>
        </div>
         <div class="row mb-3">
            <label class="col-sm-5 col-form-label col-form-label">Başvuru Durumu:</label>
            <div class="col col-form-label col-form-label">
                <Loader :loading="true" :load="loading">
                    <ul>
                        <li v-for="(resp,i) in response" :key="i">{{ resp }}</li>
                    </ul>
                </Loader>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
            <div>
                <b-button variant="light" @click="close()">Vazgeç</b-button>
            </div>
        </div>
    </form>
</b-modal>
</template>